import {__} from "~/ts/library/Translate";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import Dictionary from "~/ts/library/Dictionary";

export type ShowTypeId = typeof SHOW_TAB_TYPE_SHOW | typeof SHOW_TAB_TYPE_BUTTON;
export const SHOW_TAB_TYPE_SHOW = "show";
export const SHOW_TAB_TYPE_BUTTON = "button";

export function getSendTabShowTypes(): {
    id: ShowTypeId,
    descr: string
}[] {
    return [
        {
            id: SHOW_TAB_TYPE_SHOW,
            descr: __('Сразу открыть')
        },
        {
            id: SHOW_TAB_TYPE_BUTTON,
            descr: __('Отобразить кнопку в чате')
        }
    ]
}

export async function sendTab(username: string, tabId: string, showType: ShowTypeId, additionalParams?: Dictionary<any>) {
    let p: OperatorApplicationApi.OperatorMessageSendTabOpenApiModel = {
        username,
        tabId,
        showType,
        ...(additionalParams ?? {})
    };
    return await ((new OperatorApiRequest({
        url: "/message/sendTab",
        p
    }))).send();
}